import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";

import Legel_Entity_view_offcanvas from "../legel_Entity_view_offcanvas/Legel_Entity_view_offcanvas";
import Legel_Entity_Edit_offcanvas from "../legel_Entity_Edit_offcanvas/Legel_Entity_Edit_offcanvas";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import {
  GetAll,
  Delete,
} from "../../../../../../../features/admin/quality_management/structural_requirement/legal_entity/Slice";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "../../../../../../../utils/common";
import { FixIDS } from "../../../../../../../utils/fixIDS";
import Delete_offcanvas from "../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";

function Legel_Entity_table() {
  const [view, setView] = useState(false);
  const [viewId, setViewId] = useState(null);
  const [showEdit, setEdit] = useState(false);
  const [showEditId, setEditId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const legal_entity = useSelector((state) => state.legal_entity);
  console.log("legal_entity", legal_entity);

  const [showDelete, setDelete] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const dispatch = useDispatch();
  /* ================= FETCH LIST ================= */
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: legal_entity.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);

  const data = [
    {
      legalEntityName: "NLC INDIA LIMITED",
      legalEntityType: "Companies Act",
      dateOfEstablishment: "14 JAN 2025",
      otherAccreditations: "_ _ _",
    },
  ];

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* ================= DELETE ================= */
  const handleDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await dispatch(Delete(selectedDeleteId)).unwrap(); // call redux thunk
      fetchCustomers(currentPage); // refresh the table
      // setDelete(false); // close offcanvas
      setSelectedDeleteId(null); // reset
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(FixIDS.legel_entity.List);
  const haveEditPermission = permissions?.includes(FixIDS.legel_entity.Edit);
  const haveDeletePermission = permissions?.includes(
    FixIDS.legel_entity.Delete,
  );
  const haveViewPermission = permissions?.includes(FixIDS.legel_entity.View);
  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Date</th>
                  <th>Legal Entity Name</th>
                  <th>Legal Entity Type</th>
                  <th>Date Of Establishment</th>
                  <th>Type Of Service</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {legal_entity?.data.map((row, index) => (
                  <tr key={index}>
                    {/* <td>{index+1}</td> */}
                    <td>
                      {(legal_entity?.current_page - 1) *
                        legal_entity?.per_page +
                        index +
                        1}
                    </td>
                    <td>{formatDate(row?.createdAt)}</td>
                    {/* Legal Entity Name */}
                    <td>{row.name}</td>

                    {/* Legal Entity Type */}
                    <td>{row.legal_entity}</td>

                    <td>
                      {row.createdAt
                        ? new Date(
                            row.date_of_establishment,
                          ).toLocaleDateString("en-IN")
                        : "-"}
                    </td>

                    {/* Other Accreditations */}
                    <td>{row.other_accereditation}</td>

                    {/* Action */}
                    <td>
                      <div className="action_icons">
                        {haveViewPermission && (
                          <FontAwesomeIcon
                            icon={faEye}
                            onClick={() => {
                              setView(true);
                              setViewId(row.id);
                            }}
                          />
                        )}
                        {haveEditPermission && (
                          <FontAwesomeIcon
                            icon={faPen}
                            onClick={() => {
                              setEdit(true);
                              setEditId(row.id);
                            }}
                          />
                        )}
                        {haveDeletePermission && (
                          <FontAwesomeIcon
                            icon={faTrashCan}
                            onClick={() => {
                              setSelectedDeleteId(row.id); // store ID
                              setDelete(true); // open offcanvas
                            }}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="comon_page_footer">
          <div className="show_entry_div">
            <p className="show_text">
              Showing{" "}
              {(legal_entity.current_page - 1) * legal_entity.per_page + 1} To{" "}
              {Math.min(
                legal_entity.current_page * legal_entity.per_page,
                legal_entity.total,
              )}{" "}
              Of {legal_entity.total} Entries
            </p>
          </div>

          <div className="pagination_div">
            <Pagination_Holder
              onPageChange={legal_entity.current_page}
              totalPages={legal_entity.total_pages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>

      {/* VIEW */}
      {haveReadPermission && (
        <Legel_Entity_view_offcanvas
          show={view}
          handleClose={() => setView(false)}
          id={viewId}
        />
      )}

      {/* Edit */}
      {haveEditPermission && (
        <Legel_Entity_Edit_offcanvas
          show={showEdit}
          handleClose={() => setEdit(false)}
          id={showEditId}
        />
      )}


      { haveDeletePermission && <Delete_offcanvas
        show={showDelete}
        handleClose={() => setDelete(false)}
        handleDelete={handleDelete}
        offcanvasHeading="Delete Legal Entity"
        massageText={"Legal Entity"}
      />}
    </>
  );
}

export default Legel_Entity_table;
